var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseContract } from './baseContract.js';
import { Web3Contract } from './web3Contract.js';
import { AElfContract } from './aelfContract.js';
export class ContractBasic extends BaseContract {
    constructor(options) {
        super(options);
        this.calculateTransactionFee = (functionName, paramsOption) => __awaiter(this, void 0, void 0, function* () {
            if (this.callContract instanceof AElfContract)
                return this.callContract.calculateTransactionFee(functionName, paramsOption);
            // TODO WEB3 Contract
            return { data: '' };
        });
        this.callContract = this.type === 'aelf' ? new AElfContract(options) : new Web3Contract(options);
    }
    callViewMethod(functionName, paramsOption, callOptions) {
        return this.callContract.callViewMethod(functionName, paramsOption, callOptions);
    }
    callSendMethod(functionName, account, paramsOption, sendOptions) {
        return this.callContract.callSendMethod(functionName, account, paramsOption, sendOptions);
    }
    encodedTx(functionName, paramsOption, callOptions) {
        return this.callContract.encodedTx(functionName, paramsOption, callOptions);
    }
}
